export default "__VITE_ASSET__886ee279__"